// 全局记忆 mixin：各模块通过在 $options.lastModuleConfig 中声明启用
// 示例：
//   lastModuleConfig: {
//     modulePath: "/homePage/productionOrder", // 一级模块路由
//     topTabVar: "tabPaneValue",               // 固定顶级Tab 状态字段（仅当存在多个固定Tab且有记忆价值时声明）
//     topTabs: ["first","user"],               // 合法的固定顶级Tab值（用于校验，不在其中则不恢复）
//     subTabs: { cutView: [true,false] }       // 二级Tab字段+合法值（不传数组则不过滤）
//   }
//
// 行为：
//   - 进入模块（created/activated）时，若记忆属于本模块则恢复 顶级Tab 与 二级Tab
//   - 进入/切换时自动记录 顶级Tab 与 二级Tab（通过 $watch 监听，无需改动各切换方法）
import Vue from "vue";
import { getLastModule, setLastModule } from "@/utils/lastModule.js";

function read() {
  return getLastModule() || {};
}

function subTabsOf(d, modulePath) {
  if (!d.subTabs) d.subTabs = {};
  if (!d.subTabs[modulePath]) d.subTabs[modulePath] = {};
  return d.subTabs[modulePath];
}

Vue.mixin({
  created() {
    const cfg = this.$options.lastModuleConfig;
    if (!cfg) return;
    this._lmCfg = cfg;
    this._lmApply();
    // 动态监听各二级Tab字段变化并记录
    (cfg.subTabs ? Object.keys(cfg.subTabs) : []).forEach((f) => {
      this._lmUnwatch = this._lmUnwatch || [];
      this._lmUnwatch.push(
        this.$watch(f, (nv) => {
          if (this._lmRestoring || !this._lmCfg) return;
          this._lmRecordSubTab(f, nv);
        })
      );
    });
    this.$nextTick(() => {
      this._lmRecordPath();
    });
  },
  activated() {
    const cfg = this.$options.lastModuleConfig;
    if (!cfg) return;
    this._lmCfg = cfg;
    this._lmApply();
  },
  beforeDestroy() {
    this._lmCfg = null;
    if (this._lmUnwatch) {
      this._lmUnwatch.forEach((uw) => uw());
      this._lmUnwatch = [];
    }
  },
  methods: {
    // 恢复记忆
    _lmApply() {
      const cfg = this._lmCfg;
      if (!cfg) return;
      const d = read();
      if (!d || d.modulePath !== cfg.modulePath) return;
      this._lmRestoring = true;
      // 顶级Tab（仅在合法固定值内恢复）
      const topVar = cfg.topTabVar;
      if (topVar && d.tab !== undefined && this[topVar] !== undefined) {
        if (Array.isArray(cfg.topTabs) && cfg.topTabs.length && !cfg.topTabs.includes(d.tab)) {
          // 非法（如动态工单id）不恢复
        } else {
          this[topVar] = d.tab;
        }
      }
      // 二级Tab（来自本模块命名空间）
      const mySub = (d.subTabs && d.subTabs[cfg.modulePath]) || {};
      Object.keys(cfg.subTabs || {}).forEach((f) => {
        const legal = cfg.subTabs[f];
        const sv = mySub[f];
        if (sv === undefined || this[f] === undefined) return;
        if (Array.isArray(legal) && legal.length && !legal.includes(sv)) return;
        this[f] = sv;
      });
      this.$nextTick(() => {
        this._lmRestoring = false;
      });
    },
    // 记录一级模块路径
    _lmRecordPath() {
      const cfg = this._lmCfg;
      if (!cfg) return;
      const d = read();
      d.modulePath = cfg.modulePath;
      setLastModule(d);
    },
    // 记录顶级Tab
    _lmRecordTab(tab) {
      const d = read();
      d.modulePath = this._lmCfg.modulePath;
      d.tab = tab;
      setLastModule(d);
    },
    // 记录二级Tab（本模块命名空间）
    _lmRecordSubTab(field, value) {
      const d = read();
      d.modulePath = this._lmCfg.modulePath;
      subTabsOf(d, this._lmCfg.modulePath)[field] = value;
      setLastModule(d);
    },
    // 供子模块调用：记录二级Tab
    $rememberSubTab(field, value) {
      if (!this._lmCfg) return;
      this._lmRecordSubTab(field, value);
    },
  },
  watch: {
    tabPaneValue(val) {
      const cfg = this.$options.lastModuleConfig;
      if (!cfg || !cfg.topTabVar || cfg.topTabVar !== "tabPaneValue") return;
      if (this._lmRestoring) return;
      if (this._lmCfg) this._lmRecordTab(val);
    },
  },
});
